import { render, staticRenderFns } from "./GmbVerificationDialog.vue?vue&type=template&id=12d49a8a&scoped=true&"
import script from "./GmbVerificationDialog.vue?vue&type=script&lang=js&"
export * from "./GmbVerificationDialog.vue?vue&type=script&lang=js&"
import style0 from "./GmbVerificationDialog.vue?vue&type=style&index=0&id=12d49a8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d49a8a",
  null
  
)

export default component.exports